(function () {
  'use strict';
  if (window.WagmadeProductRailLoaded) return;

  function createRail(root) {
    var view = root.ownerDocument.defaultView;
    var rail, cards, navigation, previous, next, position, observer, frame;
    var initialized = false;

    function update() {
      frame = null;
      if (!initialized) return;
      var box = rail.getBoundingClientRect();
      var visible = cards.map(function (card, index) {
        var rect = card.getBoundingClientRect();
        return rect.left >= box.left - 2 && rect.right <= box.right + 2 ? index : -1;
      }).filter(function (index) { return index >= 0; });
      var overflowing = rail.scrollWidth > rail.clientWidth + 2;
      navigation.hidden = !overflowing;
      previous.setAttribute('aria-disabled', String(rail.scrollLeft <= 2));
      next.setAttribute('aria-disabled', String(rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2));
      if (visible.length) {
        position.textContent = (visible[0] + 1) + (visible.length > 1 ? '–' + (visible[visible.length - 1] + 1) : '') + ' / ' + cards.length;
      }
    }
    function schedule() {
      if (frame == null) frame = view.requestAnimationFrame(update);
    }
    function scrollBehavior() {
      return view.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    }
    function move(direction) {
      var control = direction < 0 ? previous : next;
      if (control.getAttribute('aria-disabled') === 'true') return;
      var gap = parseFloat(view.getComputedStyle(rail).columnGap) || 0;
      var stride = cards[0].getBoundingClientRect().width + gap;
      var page = Math.max(1, Math.floor(rail.clientWidth / stride));
      rail.scrollBy({ left: direction * stride * page, behavior: scrollBehavior() });
      schedule();
    }
    function back() { move(-1); }
    function forward() { move(1); }
    function keyboard(event) {
      if (event.target !== rail) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth, behavior: scrollBehavior() });
      }
    }
    function init() {
      destroy();
      rail = root.querySelector('.wm-product-display__grid:not(.wm-product-display__grid--empty)');
      navigation = root.querySelector('[data-wm-rail-navigation]');
      if (!rail || !navigation) return;
      cards = Array.from(rail.querySelectorAll('[data-wm-product-card]'));
      if (!cards.length) return;
      previous = navigation.querySelector('[data-wm-rail-previous]');
      next = navigation.querySelector('[data-wm-rail-next]');
      position = navigation.querySelector('[data-wm-rail-position]');
      initialized = true;
      rail.addEventListener('scroll', schedule, { passive: true });
      rail.addEventListener('keydown', keyboard);
      previous.addEventListener('click', back);
      next.addEventListener('click', forward);
      view.addEventListener('resize', schedule, { passive: true });
      if (view.ResizeObserver) {
        observer = new view.ResizeObserver(schedule);
        observer.observe(rail);
      }
      update();
    }
    function destroy() {
      if (frame != null) view.cancelAnimationFrame(frame);
      frame = null;
      if (observer) observer.disconnect();
      observer = null;
      if (!initialized) return;
      rail.removeEventListener('scroll', schedule);
      rail.removeEventListener('keydown', keyboard);
      previous.removeEventListener('click', back);
      next.removeEventListener('click', forward);
      view.removeEventListener('resize', schedule);
      navigation.hidden = true;
      initialized = false;
    }
    return { init: init, refresh: init, destroy: destroy };
  }

  function start() {
    if (!window.WagmadeTheme || window.WagmadeProductRailLoaded) return;
    window.WagmadeTheme.register('homepage-product-rail', '[data-wm-product-rail="browse"]', createRail);
    window.WagmadeProductRailLoaded = true;
    window.WagmadeTheme.init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', start, { once: true });
})();
